/* eslint-disable */
export default function props(){
  return {
    toggleActions: 'none play none reset',
    start: '-64px bottom',
    end: '0 80%',
    transitionTimingFunction: 'cubic-bezier(.07,.63,.36,.96) 1.5s',
    styleTransformY: 'translateY(48px)',
    styleTransformX: 'translateX(-48px)'
  }
}
